<template>
  <div style="padding:20px;">
    <h1>Location Summary</h1>
    <DatePeriodSelector v-model="timestamps" lsComponentName='LocationSummary'/>
    
    <!-- <p>🌟NEW!🌟 I've categorized the Cig Distributors and can now report on their respective shares.</!-->

    <p>Report from {{formatDate(timestamps.from)}} to {{formatDate(timestamps.to)}}</p>
    <div style="width:350px;">
      <LocationSummaryTable :compareTo="lastYearData" :timestamps="timestamps" />
    </div>

    <p>Last Year: {{formatDate(lastYear(timestamps.from))}} to {{formatDate(lastYear(timestamps.to))}}</p>
    
    <div style="width:350px;">
      <LocationSummaryTable v-model="lastYearData" :timestamps="lastYearTimestamps" />
    </div>

    <!-- <h1>Top Sales</h1>
    <div style="350px">
      <TopSalesTable v-model="topSalesData" :timestamps="timestamps" :qualifier="{top:10, notSubtypes:['Gas'],}"/>
    </div> -->
  </div>

</template>

<script>
import DatePeriodSelector from '@/components/DatePeriodSelector.vue'
import LocationSummaryTable from './components/LocationSummaryTable.vue'
import TopSalesTable from '../LocationTopSales/components/TopSalesTable.vue'

export default {
  name: 'LocationSummary',
  components: {DatePeriodSelector, LocationSummaryTable, TopSalesTable},
  data () { return {
    thisYearData: {}, 
    lastYearData: {},
    topSalesData: {}, 
    timestamps: {
      from: undefined,
      to: undefined,
    },
    previousTimestamps: {
      from: undefined,
      to: undefined,
    },
    } 
  },
  watch: {
    
  },
  methods: {
    lastYear: function(date){
      //Leap year bug, probably needs adjusting
      // return moment(date).subtract(1, 'year').add(moment(date).isLeapYear() ? 2 : 1,'day');
      return moment(date).subtract(52, 'week');
    },
    formatDate: function(date, formatStyle="ddd YYYY-MM-DD h:mm a"){
      return moment(date).format(formatStyle);
    },
  },
  computed: {
    lastYearTimestamps: function(){
      const result = {...this.timestamps}
      result.from = this.lastYear(result.from)
      result.to = this.lastYear(result.to)
      return result
    }
  }
}
</script>

<style>
.selected{
  /* opacity: 0.6; */
  background-color: darkgray;
}
</style>
